import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import classnames from 'classnames';
import { ADMIN_ROOT } from 'common/variables';
import Filter from 'common/filter/containers';
import { TYPE_STRING } from 'common/filter/constants';
import Money from 'common/components/money';
import Thumbnail from 'common/components/thumbnail';
import StarRating from 'common/components/star_rating';
import RevisionDisclosures from 'entries/containers/revision_disclosures';
import ProjectEntryMenu from 'admin/containers/project_entries/actions_menu';
import UserEntryMenu from 'admin/components/user_entries/actions_menu';
import { PROJECT_ENTRIES_RESOURCE_NAME } from 'admin/constants';

export default class ImageNameTile extends Component {
  constructor(props) {
    super(props);

    this.state = { menuOpen: false };
  }

  renderThumbnail() {
    const { item } = this.props;
    const revision = item.revisions[0];
    const thumbClasses = classnames('tile entry-thumbnail', {
      withdrawn: item.withdrawn,
      stacked: item.revisions.length > 1,
    });

    return (
      <Thumbnail className={thumbClasses}
        image={item.entry_type === 'name'? null : revision.thumbnails[0]}>

        { item.entry_type === "name" && <div className="revision-name">{ revision.name }</div> }

        { (item.withdrawn || item.eliminated) &&
        <div className={classnames("flag info", { "extended": item.withdrawn && item.eliminated })}>
          <div>
            { item.withdrawn && <span>withdrawn</span> }
            { item.withdrawn && item.eliminated && <br/> }
            { item.eliminated && <span>eliminated</span> }
          </div>
        </div> }

        { item.winner &&
        <div className="flag winner with-value">
          <div>
            <span>Winner</span>
            <Money className="value" value={item.award_value} />
          </div>
        </div> }

        { item.runnerup && !item.winner &&
        <div className="flag winner with-value">
          <div>
            <span>Finalist</span>
            <Money className="value" value={item.award_value} />
          </div>
        </div> }

        { !!parseFloat(item.tip_value) &&
        <div className="flag tipped with-value">
          <div>
            <span>Tipped</span>
            <Money className="value" value={item.tip_value} />
          </div>
        </div> }

        { !!parseFloat(item.offer_value) &&
        <div className="flag tipped with-value">
          <div>
            <span>Offered</span>
            <Money className="value" value={item.offer_value} />
          </div>
        </div> }
      </Thumbnail>
    );
  }

  render() {
    const { menuOpen } = this.state;
    const { item, grouped, viewType, variation } = this.props;
    const revision = item.revisions[0];
    const authorUsernameTrimmed = (
      item.author_username.length > 25? item.author_username.substring(0, 25) : item.author_username
    );
    const link = `${ADMIN_ROOT}/project/${item.project}/entry/${item.id}/?revision=${revision.id}`;
    const Menu = variation === "adminUserEntries"? UserEntryMenu : ProjectEntryMenu;

    return (
      <div className="column column-block entry">
        <div className="entry-tile">
          <div className="tile-left">
            <div className={classnames('tile-tools', { '--menu-open': menuOpen })}>
              <Menu entry={item} onToggle={o => this.setState({ menuOpen: o })} />
            </div>

            <Link to={link} target="_blank">{ this.renderThumbnail() }</Link>

            <StarRating key={item.id} readonly={true} initialRate={revision.score || 0}
              extraClasses="lg" />
          </div>
          <div className="tile-right">
            <p className="revision-author">
              <span className="entry-number">
                #{ grouped ? item.entry_number : revision.revision_number }
              </span> by {' '}

              { variation === "adminProjectEntries"?
              <Filter field="entry_author_username" type={TYPE_STRING} string={item.author_username}
                stringLabel={authorUsernameTrimmed} resourceName={PROJECT_ENTRIES_RESOURCE_NAME} /> :
              <Link to={`${ADMIN_ROOT}/creative/${item.author}/`} target="_blank">
                { authorUsernameTrimmed }
              </Link> }{' '}

              <span className="revision-time">{ moment(revision.created_at).fromNow() }</span>
            </p>
            { viewType === "list" &&
            <div className="revision-description">
              <h4>Description:</h4>
              <p>{ revision.description }</p>
            </div> }
            { viewType === "list" &&
            <RevisionDisclosures entry={item} revision={revision} canViewAssetPrice={true} /> }
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

ImageNameTile.propTypes = {
  item: PropTypes.object.isRequired,
  viewType: PropTypes.string.isRequired,
  variation: PropTypes.string.isRequired,
  grouped: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./admin/components/entries/image_name_tile.jsx